import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Hot: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[16px] h-[16px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.12937 2.17394C7.32866 2.09139 7.55805 2.13702 7.71059 2.28956C8.12785 2.70682 8.66683 3.64093 8.93431 4.7144C9.16905 5.65651 9.21509 6.791 8.71115 7.83168C8.83413 7.8808 8.91619 7.86811 8.99131 7.83809C9.09531 7.79653 9.25119 7.69389 9.46408 7.45647C9.67512 7.2211 9.92022 6.87813 10.2085 6.39386C10.2955 6.2478 10.4468 6.15194 10.616 6.13577C10.7853 6.11959 10.952 6.18504 11.0651 6.31198C11.4339 6.72609 11.7949 7.36332 12.0625 8.01196C12.3289 8.6578 12.5335 9.38903 12.5335 10C12.5335 11.2023 12.0558 12.3554 11.2057 13.2056C10.3555 14.0557 9.20245 14.5333 8.00013 14.5333C6.79782 14.5333 5.64474 14.0557 4.79458 13.2056C3.94441 12.3554 3.4668 11.2023 3.4668 10C3.4668 8.69363 4.03298 7.23845 4.95122 6.29475L4.95152 6.29444C4.97479 6.27056 4.99821 6.24657 5.02175 6.22246C5.83733 5.38708 6.80013 4.40089 6.80013 2.66668C6.80013 2.45097 6.93007 2.25649 7.12937 2.17394ZM7.64212 4.19594C7.2476 5.47417 6.41533 6.32404 5.81526 6.9368C5.78119 6.97159 5.74786 7.00562 5.71541 7.03892L5.33346 6.66668L5.71571 7.03861C4.99928 7.77491 4.53346 8.95973 4.53346 10C4.53346 10.9194 4.8987 11.8012 5.54883 12.4513C6.19895 13.1014 7.08071 13.4667 8.00013 13.4667C8.91955 13.4667 9.80131 13.1014 10.4514 12.4513C11.1016 11.8012 11.4668 10.9194 11.4668 10C11.4668 9.58966 11.3193 9.00756 11.0764 8.41873C10.9576 8.13075 10.8234 7.859 10.6867 7.62237C10.5402 7.83115 10.3978 8.01287 10.2582 8.16856C9.98544 8.4728 9.7002 8.70349 9.38712 8.8286C8.68576 9.10886 8.10226 8.77662 7.66021 8.41098C7.44863 8.23598 7.40449 7.92893 7.55822 7.70142C8.10887 6.88645 8.12887 5.89368 7.89929 4.97229C7.82998 4.69414 7.74037 4.43262 7.64212 4.19594Z"
      fill="#FF4035"
    />
  </svg>
);

export default Hot;
